// Product → internal page-slug resolution for storefront navigation.
//
// Navigation is keyed on the STABLE Shopify product ID, never the handle:
// handles can change in the Shopify admin and are unreliable, whereas the id and
// our own page slug are stable. `buildSlugByProductId` produces a
// productId → slug map so a "Learn more" click (which carries the live product's
// id) routes to our controllable internal slug.
//
// Legacy pages that predate the product-id backfill carry only a handle. For
// those we derive the id→slug entry ONCE from the current catalog (a transient,
// session-only bootstrap — never persisted, never placed in a URL). The entry
// becomes pure-id the moment the page is opened + published in the editor.

interface ProductPageLike { handle: string | null; slug: string; productId?: string | null }
interface ProductLike { id: string; handle: string }

export function buildSlugByProductId(
  productPages: ProductPageLike[],
  products: ProductLike[],
): Map<string, string> {
  const m = new Map<string, string>();
  for (const pp of productPages) {
    if (!pp.slug) continue;
    if (pp.productId) { m.set(pp.productId, pp.slug); continue; }
    const prod = pp.handle ? products.find((p) => p.handle === pp.handle) : undefined;
    if (prod) m.set(prod.id, pp.slug);
  }
  return m;
}
